module.exports = __webpack_public_path__ + "media/images/pdf-icon-dadf201915ee168e9e34f167465936b1.svg";